/*
 Author: @Rizwan ullah

 */
import React, { useState } from 'react';
import { MapContainer, useMapEvents, TileLayer, Marker, Popup } from 'react-leaflet';
import Geocode from 'react-geocode';
import { useDispatch } from 'react-redux';
import { mapCoordinates } from '../reduxToolkit/UpdateCompany/UpdateCompanySlice';
import 'leaflet.fullscreen';
import 'leaflet.fullscreen/dist/Control.FullScreen.css';

function AddMarkerToClick({ latlng }) {
    const [markers, setMarkers] = useState(latlng);
    const dispatch = useDispatch();

    const map = useMapEvents({
        click(e) {
            setMarkers([e.latlng.lat, e.latlng.lng]);

            Geocode.setApiKey('AIzaSyDRCcydEnjt7P-riOx4X-Dm4F1HDntPEDg');
            Geocode.fromLatLng(e.latlng.lat, e.latlng.lng).then(
                (response) => {
                    const address = response.results[0].formatted_address;
                    const body = {
                        address,
                        lat: e.latlng.lat,
                        lng: e.latlng.lng,
                    };

                    dispatch(mapCoordinates(body));
                },
                (error) => {
                    console.error(error);
                },
            );
        },
    });

    return (
        <>
            {
                <Marker key={markers[0]} position={markers}>
                    <Popup>Marker is at {markers}</Popup>
                </Marker>
            }
        </>
    );
}

const LefletMap = ({ latlng, handleMapClick }) => {
    return (
        <>
            {
                <MapContainer
                    center={latlng}
                    zoom={4}
                    style={{ height: '200%', width: '200%', borderRadius: '5px' }}
                    onClick={handleMapClick}
                    fullscreenControl={true}
                >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                    />
                    <AddMarkerToClick latlng={latlng} />
                </MapContainer>
            }
        </>
    );
};

export default LefletMap;
